// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--black: #000;
	--white: #fff;
	--brand: #0f0;
	--gray: #f3f3f3;
	--gray2: #dfdfdf;
	--gray3: #666;
	--green: #38a126;

	--main-width: 700px;
	--main-padding-horizontal: 50px;
}
.gzcz1NpJ0Qm2AJzLzHir {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	flex: 1;
	margin-top: 24px;
}
@media not screen and (max-width: 767px) {
.gzcz1NpJ0Qm2AJzLzHir {
		justify-content: center;
		max-width: 700px;
		max-width: var(--main-width);
		padding: 0 50px;
		padding: 0 var(--main-padding-horizontal);
		width: 100%;
}
	}
@media (max-width: 767px) {
.gzcz1NpJ0Qm2AJzLzHir {
		justify-content: flex-end;
		padding: 0;
}
	}
`, "",{"version":3,"sources":["webpack://./src/stylesheets/variables.pcss","webpack://./src/components/Main/Main.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,aAAa;CACb,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,gBAAgB;;CAEhB,mBAAmB;CACnB,+BAA+B;AAChC;ACRA;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;CAC3B,OAAO;CACP,gBAAgB;AAajB;AAXC;AAPD;EAQE,uBAAuB;EACvB,gBAA4B;EAA5B,4BAA4B;EAC5B,eAAyC;EAAzC,yCAAyC;EACzC,WAAW;AAOb;CANC;AAEA;AAdD;EAeE,yBAAyB;EACzB,UAAU;AAEZ;CADC","sourcesContent":[":root {\n\t--black: #000;\n\t--white: #fff;\n\t--brand: #0f0;\n\t--gray: #f3f3f3;\n\t--gray2: #dfdfdf;\n\t--gray3: #666;\n\t--green: #38a126;\n\n\t--main-width: 700px;\n\t--main-padding-horizontal: 50px;\n}\n","@import './../../stylesheets/media-queries.pcss';\n@import './../../stylesheets/variables.pcss';\n\n.main {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\tflex: 1;\n\tmargin-top: 24px;\n\n\t@media not screen and (--mobile) {\n\t\tjustify-content: center;\n\t\tmax-width: var(--main-width);\n\t\tpadding: 0 var(--main-padding-horizontal);\n\t\twidth: 100%;\n\t}\n\n\t@media (--mobile) {\n\t\tjustify-content: flex-end;\n\t\tpadding: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `gzcz1NpJ0Qm2AJzLzHir`
};
export default ___CSS_LOADER_EXPORT___;
